<template>
  <table class="table is-shadowless is-fullwidth is-hoverable">
    <thead>
      <tr class="has-text-centered">
        <th rowspan="2" style="vertical-align: bottom; width: 15%;">Asignatura</th>
        <th rowspan="2" style="vertical-align: bottom;  width: 45%;">Nombre</th>
        <th class="has-text-centered" :colspan="snapshots" style="border: none;">Corte</th>
        <th rowspan="2" style="vertical-align: bottom;">Final</th>
        <th rowspan="2" style="vertical-align: bottom;">Estado</th>
      </tr>
      <tr class="has-text-left">
        <th v-for="n in snapshots">{{ n }}</th>
      </tr>
    </thead>
    <tbody v-if="collapsed.length > 0">
      <tr v-for="g in collapsed" :class="{ disabled: g.disabled }">
        <td>{{ g.courseCode }}</td>
        <td>{{ g.courseName }}</td>
        <td v-for="s in snapshots" :class="g.snapshots[s - 1] < gradeThreshold && 'deficient'">
          {{ g.snapshots[s - 1] }}
        </td>
        <td :class="g.final < gradeThreshold && 'deficient'">{{ g.final }}</td>
        <td>{{ g.status }}</td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td :colspan="6">Sin registro de notas para este periodo</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "TermGradesTable",
  props: {
    gradeThreshold: {
      default: 3,
      type: Number
    },
    snapshots: {
      type: Number,
      default: 3
    },
    grades: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    collapsed() {
      const ret = {}
      this.grades.forEach(g => {
        // Have we seen this course?
        if (!ret[g.courseCode]) {
          ret[g.courseCode] = {
            courseCode: g.courseCode,
            courseName: g.courseName,
            snapshots: Array(this.snapshots).fill(null),
            // By default, courses have no final grade
            // unless we find one later
            final: null,
            // By default, the course is active
            // until we have a grade that says otherwise
            disabled: false,
            status: g.status
          }
        }
        // Retrieve head
        const head = ret[g.courseCode]

        // Check if we have a final snapshot. for the course
        if (g.isFinal) {
          head.final = g.grade.grade
        } else {
          head.snapshots[g.snapshot - 1] = g.grade.grade
        }

        // Check if the course is still active
        if (g.isActive === false) {
          head.disabled = true
        }
      })
      return Object.values(ret)
    }
  }
}
</script>

<style scoped>
.deficient {
  color: #ff5f58;
}
tr.disabled {
  opacity: 0.4;
}
tr.disabled .deficient {
  color: inherit;
}
</style>
